import { render, staticRenderFns } from "./ProductsPage.vue?vue&type=template&id=952877e6&scoped=true&"
import script from "./ProductsPage.vue?vue&type=script&lang=js&"
export * from "./ProductsPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductsPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductsPage.vue?vue&type=style&index=1&id=952877e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952877e6",
  null
  
)

export default component.exports